var AVState = function() {
  var self = this;

  var currentIndex = 0;
  var pushStateListeners = [];
  var popStateListeners = [];

  var callListener = function(type, value) {
    var listeners;
    switch (type) {
      case 'push':
        listeners = pushStateListeners;
        break;
      case 'pop':
        listeners = popStateListeners;
        break;
      default:
        listeners = [];
    }

    for (var i = 0; i < listeners.length; i++) {
      listeners[i](value);
    }
  }

  self.states = [{
    index: 0
  }];
  
  Object.defineProperty(self, 'current', {
    get: function() {
      return history.state || {};
    }
  });

  self.addListener = function(type, listener) {
    if (typeof listener === 'function') {
      switch (type) {
        case 'push':
          pushStateListeners.push(listener);
          break;
        case 'pop':
          popStateListeners.push(listener);
          break;
      }
    }
  };

  self.push = function(state, replace) {
    state = state || {};

    if (!replace) {
      replace = self.alwaysReplace(state);
    }

    if (currentIndex < self.states.length - 1) {
      self.states.splice(currentIndex + 1);
    }

    if (replace) {
      if (self.states.length) {
        self.states[currentIndex] = state;
      } else {
        self.states.push(state);
      }
    } else {
      self.states.push(state);
      currentIndex++;
    }

    state.index = currentIndex;

    callListener('push', state);

    // Push/replace to browser history
    history[replace ? 'replaceState' : 'pushState'](state, null, state.url || null);
  };

  self.replace = function(state) {
    self.push(state, true);
  };

  self.pop = function() {
    history.back();
  };

  self.init = function(options) {
    options = options || {};
    
    // Always replace on state push
    if (typeof options.alwaysReplace === 'function') {
      self.alwaysReplace = options.alwaysReplace;
    } else {
      var alwaysReplace = typeof options.alwaysReplace === 'boolean' ? options.alwaysReplace : false;
      self.alwaysReplace = function() { return alwaysReplace; };
    }

    var initialState = self.current;
    if (initialState && typeof initialState.index === 'number') {
      // Attempt to rebuild state list
      for (var i = 0; i < initialState.index; i++) {
        self.states.push({});
      }
      
      self.states.push(initialState);
      currentIndex = self.states.length - 1;

      callListener('push', initialState);
    };

    $(window).bind('popstate', function(e) {
      var eventState = e.originalEvent.state || {
        index: 0
      };
      
      if (typeof eventState.index === 'number') {
        if (eventState.index < currentIndex) {
          for (var i = currentIndex; i > eventState.index; i--) {
            var state = self.states[i];

            callListener('pop', state);
          }
        } else if (eventState.index > currentIndex) {
          for (var i = currentIndex + 1; i < eventState.index; i++) {
            var state = self.states[i];
            
            callListener('push', state);
          }
        }
  
        currentIndex = eventState.index;
        self.states[currentIndex] = eventState;
        callListener('push', eventState);
      }
    });
  };
};

window.AVState = new AVState();